define('modules/editor/views/editors/text',['require','exports','module','ckeditor','common/views/modal_view','../../models/editorstate','ckeditorJQuery','ldsh!../../templates/editors/text','common/ckeditor/config_amp','common/ckeditor/config'],function(require,exports,module){
  "use strict";
  var ckeditor = require("ckeditor"),
      ModalView = require("common/views/modal_view"),
      EditorState = require("../../models/editorstate");

  require("ckeditorJQuery");

  var TextEditorView = ModalView.extend({
    template: require("ldsh!../../templates/editors/text"),
    events: {
      "click .js-save": "saveModal",
      "click .js-close": "closeModal"
    },
    initialize: function (options) {
      this.editorContent = options.content || "";
      this.CKEditorConfig = this.getCKEditorConfig();
    },
    getCKEditorConfig: function () {
      if (EditorState.getAMPState()) {
        return require("common/ckeditor/config_amp");
      }

      return require("common/ckeditor/config");
    },
    helpers: function(){
      return {
        content: this.editorContent,
        isAMP: EditorState.getAMPState()
      };
    },
    getEditorContent: function() {
      return this.$("#ckeditor").val();
    },
    closeModal: function(){
      this.hide();
    },
    saveModal: function(e){
      e.preventDefault();
      this.trigger("modal:save", this.getEditorContent());
    },
    onRender: function(){
      CKEDITOR.disableAutoInline = true;
      this.editor = this.$("#ckeditor").ckeditor(this.CKEditorConfig);
      this.$el.i18n();
    },
    onHide: function(){
      //destroy the editor for garbage collection
      this.$("#ckeditor").ckeditor("destroy");
    }
  });

  module.exports = TextEditorView;
});

